export default __webpack_public_path__ + "static/728-ccbe45f4f3f14dbf74c4cf1813278d19.gif";